import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'
import type { ISPD } from '../sprites/sprites'

export interface IFontChar2 {
  w: number
  leading: number
  oy: number
  frame: ISPD
}
export interface IFontData2 {
  data: { [k: string]: IFontChar2 }
  charSpacing: number
  charWidth: number
  charHeight: number
  spaceWidth: number
  name: string
}

export interface IFontLoadData {
  chars: string
  sprite: ISPD[]
}

const objs: IFontData2[] = []

export function create(
  name: string,
  options: {
    charSpacing: number
    charWidth: number
    charHeight: number
    data: IFontLoadData[]
  },
): IFontData2 {
  let data: { [k: string]: IFontChar2 } = {}

  l.forEach(options.data, (c) => {
    l.forEach(c.chars, (d, dIdx) => {
      data[d] = {
        leading: 0,
        w: options.charWidth,
        frame: c.sprite[dIdx],
        oy: 0,
      }
    })
  })

  let obj: IFontData2 = {
    name,
    data,
    charSpacing: options.charSpacing,
    charWidth: options.charWidth,
    charHeight: options.charHeight,
    spaceWidth: options.charWidth,
  }
  objs.push(obj)
  return obj
}

export function getLetter(obj: IFontData2, letter: string) {
  let d = obj.data[letter]
  if (!d) {
    letter = letter.toUpperCase()
    d = obj.data[letter]
  }
  if (!d) {
    d = obj.data['?']
  }
  if (!d) {
    d = obj.data['a']
  }
  if (!d) {
    assert.failed('bad font! cant load letter', letter)
  }
  return d
}

export function setWidths(
  obj: IFontData2,
  chars: string,
  newWidth: number,
  leading: number,
  oy: number = 0,
) {
  l.forEach(chars, (c, cIdx) => {
    let letter = c
    let d = obj.data[letter]
    if (!d) {
      letter = letter.toUpperCase()
      d = obj.data[letter]
    }
    if (!d) {
      assert.failed('bad font! cant adjust letter', letter)
    }
    d.w = newWidth
    d.leading = leading
    d.oy = oy
  })
}
// export function setLeadings(obj: IFontData2, chars: string, leading: number) {
//   l.forEach(chars, (c, cIdx) => {
//     let letter = c.toLowerCase()
//     let d = obj.data[letter]
//     if (!d) {
//       assert.failed('bad font! cant adjust letter', letter)
//     }
//     d.leading = leading
//   })
// }
